var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkAddCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60484 0C3.38356 0 2.2123 0.485152 1.34873 1.34873C0.485152 2.2123 0 3.38356 0 4.60484V18.0652C0 19.2864 0.485152 20.4577 1.34873 21.3213C2.2123 22.1848 3.38356 22.67 4.60484 22.67H23.7327C24.3374 22.67 24.9362 22.5509 25.4949 22.3195C26.0535 22.0881 26.5612 21.7489 26.9888 21.3213C27.4164 20.8937 27.7556 20.386 27.987 19.8274C28.2184 19.2687 28.3375 18.6699 28.3375 18.0652V4.60484C28.3375 4.00013 28.2184 3.40133 27.987 2.84265C27.7556 2.28396 27.4164 1.77633 26.9888 1.34873C26.5612 0.921128 26.0535 0.581938 25.4949 0.350523C24.9362 0.119108 24.3374 0 23.7327 0H4.60484ZM4.25063 5.31328C4.25063 5.03145 4.36258 4.76116 4.56187 4.56187C4.76116 4.36258 5.03145 4.25063 5.31328 4.25063H13.1061C13.3879 4.25063 13.6582 4.36258 13.8575 4.56187C14.0568 4.76116 14.1688 5.03145 14.1688 5.31328C14.1688 5.59512 14.0568 5.86541 13.8575 6.06469C13.6582 6.26398 13.3879 6.37594 13.1061 6.37594H5.31328C5.03145 6.37594 4.76116 6.26398 4.56187 6.06469C4.36258 5.86541 4.25063 5.59512 4.25063 5.31328ZM5.6675 12.7519H15.5856C15.9614 12.7519 16.3218 12.9012 16.5875 13.1669C16.8532 13.4326 17.0025 13.793 17.0025 14.1688V17.0025C17.0025 17.3783 16.8532 17.7387 16.5875 18.0044C16.3218 18.2701 15.9614 18.4194 15.5856 18.4194H5.6675C5.29172 18.4194 4.93133 18.2701 4.66562 18.0044C4.3999 17.7387 4.25063 17.3783 4.25063 17.0025V14.1688C4.25063 13.793 4.3999 13.4326 4.66562 13.1669C4.93133 12.9012 5.29172 12.7519 5.6675 12.7519ZM5.31328 7.79281H20.1905C20.4723 7.79281 20.7426 7.90477 20.9419 8.10406C21.1412 8.30334 21.2531 8.57363 21.2531 8.85547C21.2531 9.1373 21.1412 9.40759 20.9419 9.60688C20.7426 9.80617 20.4723 9.91813 20.1905 9.91813H5.31328C5.03145 9.91813 4.76116 9.80617 4.56187 9.60688C4.36258 9.40759 4.25063 9.1373 4.25063 8.85547C4.25063 8.57363 4.36258 8.30334 4.56187 8.10406C4.76116 7.90477 5.03145 7.79281 5.31328 7.79281Z",
    fill: "url(#paint0_linear_251_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_251_3",
    x1: 1,
    y1: 6,
    x2: 14.1688,
    y2: 22.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744028,
    stopOpacity: 0.601798
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2790C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkAddCardIcon);
export default __webpack_public_path__ + "static/media/darkAddCardIcon.a628a14dd7359bff357e7f391916bd32.svg";
export { ForwardRef as ReactComponent };